export function evaluateAudienceButtonDisabled(channel) {
  if(channel === null) {
    return true
  }

  if (channel.hasOwnProperty('combined')) {
    // Propsect Only
    if (channel.combined.hasProspects && !channel.combined.hasCustomers) {
      return true
    }
    // Customer Only
    else if (!channel.combined.hasProspects && channel.combined.hasCustomers) {
      return true
    }
  }
  return false
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/validation/evaluateAudinceButtonDisabled.js